<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal,
  BButton,
  BAlert,
  BRow,
  BCol,
  BFormGroup,
  BFormCheckbox,
  AlertPlugin,
  BTab,
  BOverlay,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import TabDadosUsuario from '@/views/sistema/usuarios/list/TabDadosUsuario.vue';
import TabPerfilAcesso from '@/views/sistema/usuarios/list/TabPerfilAcesso.vue';
import UserEditTabPerfils from '@/views/app/user/users-edit/UserEditTabPerfils.vue';
import UserEditTabAccount from '@/views/app/user/users-edit/UserEditTabAccount.vue';
import axios from '@/libs/axios';
import { mapGetters } from 'vuex';
import SLSUsuarioRepresentanteService from '@/services/SistemaDKP/SLSUsuarioRepresentante.service';
import UsuarioRepresentante from '@/views/sistema/usuarios/list/UsuarioRepresentante.vue';
import UsuarioCliente from '@/views/sistema/usuarios/list/UsuarioCliente.vue';

const usuarioRepresentanteService = new SLSUsuarioRepresentanteService();
export default {
  components: {
    BOverlay,
    UsuarioCliente,
    UsuarioRepresentante,
    UserEditTabAccount,
    UserEditTabPerfils,
    BTab,
    TabDadosUsuario,
    TabPerfilAcesso,
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      require: true,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  data() {
    return {
      todosPerfils: [],
      dataFromApiPerfilsAcesso: [],
      pagination: {
        currentPage: 1,
        perPage: 5,
        totalRows: 0,
      },
      pageOptions: [3, 5, 10],
    };
  },

  watch: {
    value: {
      async handler() {
        await this.buscarPerfils();
      },
      immediate: true, // Chama buscarPerfils imediatamente após a montagem do componente
    },
  },
  methods: {
    async validateForm() {
      this.$emit('ok', this.dataForm);
      this.$bvModal.hide(this.idModal);
    },
    async fetchDataFromPerfilsAcesso() {
      try {
        const response = await axios.get('/perfilAcesso/findAll');
        this.dataFromApiPerfilsAcesso = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async buscarPerfils() {
      await this.fetchDataFromPerfilsAcesso();
      let data = this.dataFromApiPerfilsAcesso;
      data = data.filter((item) => item.perfil_acesso_ativo === 1);
      const perfilsUsuario = Array.isArray(this.dataForm?.perfils) ? this.dataForm.perfils : [];
      this.todosPerfils = data.map((item) => {
        const found = perfilsUsuario.find((perf) => perf.id_perfil_acesso === item.id);
        if (found) {
          return {
            ...item,
            status: true,
          };
        }
        return {
          ...item,
          status: false,
        };
      });
      const usuarioLogado = JSON.parse(localStorage.getItem('userData')) || null;
      let perfilsDoLogado = null;

      if (usuarioLogado?.perfils !== undefined) {
        perfilsDoLogado = usuarioLogado.perfils;
      } else if (usuarioLogado?.userData?.perfils !== undefined) {
        perfilsDoLogado = usuarioLogado.userData.perfils;
      }
      // console.log(perfilsDoLogado)
      if (perfilsDoLogado) {
        const usuarioTemPerfilAdminDKP = perfilsDoLogado.some(
          (perfil) => perfil.perfil_acesso_nome === 'AdminDKP',
        );

        if (usuarioTemPerfilAdminDKP) {
          // Faça algo se o usuário tiver o perfil "AdminDKP"
        } else {
          this.todosPerfils = this.todosPerfils.filter(
            (perfil) => perfil.perfil_acesso_nome !== 'AdminDKP',
          );
        }
      } else {
        // Faça algo se usuarioLogado ou usuarioLogado.perfils for undefined
        console.error('Erro: usuarioLogado ou usuarioLogado.perfils é undefined');
      }
    },
  },
};
</script>

<template>
  <b-modal
      ref="modal-att-usuario"
      no-close-on-backdrop
      no-close-on-esc
      size="xl"
      :id="idModal"
      :title="titleModal"
      :ok-disabled="dataForm.isDefault || dataForm.usuario_nome === ''"
      :ok-title="labelBtnOk"
      ok-variant="success"
      cancel-variant="secondary"
      body-bg-variant="light"
      cancel-title="Cancelar"
      @ok="validateForm"
      @cancel="$emit('cancel')"
      @close="$emit('cancel')"
      hide-footer
  >
    <validation-observer ref="refFormData">
      <b-tabs content-class="mt-2" justified pills>
        <b-tab active title="Dados Usuarios">
          <TabDadosUsuario
              :value="value"/>
        </b-tab>
        <b-tab title="Perfil Acesso">
          <TabPerfilAcesso
              :user-data="dataForm"
              :todos-perfils="todosPerfils"/>
        </b-tab>
        <!-- INICIO -> USUARIO x CLIENTE -->
        <b-tab title="Usuário X Cliente">
          <!-- <template #title>
            <feather-icon
                icon="UserIcon"
                size="16"
                class="mr-0 mr-sm-50"
            />
            <span class="d-none d-sm-inline">Usuário X Cliente</span>
          </template> -->

            <UsuarioCliente
                v-model="dataForm"
            />
        </b-tab>
        <!-- FIM -> USUARIO x CLIENTE -->

        <!-- INICIO -> USUARIO x REPRESENTANTE -->
        <b-tab title="Usuário X Representante">
          <!-- <template #title>
            <feather-icon
                icon="UserIcon"
                size="16"
                class="mr-0 mr-sm-50"
            />
            <span class="d-none d-sm-inline">Usuário X Representante</span>
          </template> -->
          <UsuarioRepresentante
              v-model="dataForm"
          />
        </b-tab>
        <!-- FIM -> USUARIO x REPRESENTANTE -->
      </b-tabs>
    </validation-observer>
  </b-modal>
</template>
